// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"445":"wxLogin","671":"wxHome","973":"agreement"}[chunkId] + "." + {"445":"add8b634","671":"da2aabfe","973":"1d669d5e"}[chunkId] + ".css";
};